export default "__VITE_ASSET__SJTjcVTr__"